<script>
import { getEnabledGoodsTagList, getGoodsPreviewDetail } from "@/api/product";
import { formatApiDate } from "@/utils/utils";
import { getValue, PRODUCT_STATUS, PRODUCT_TYPE } from "@/utils/enumUtile";

export default {
  name: "productInfo",
  data() {
    return {
      loading: false,
      goods: {},
      goodsTagOptions: []
    };
  },
  computed: {
    PRODUCT_TYPE() {
      return PRODUCT_TYPE;
    },
    PRODUCT_STATUS() {
      return PRODUCT_STATUS;
    },
    goodsImages() {
      return this.splitImages(this.goods.goodsGraph);
    },
    specsGroups() {
      if (!this.goods.specs) {
        return [];
      }
      try {
        return JSON.parse(this.goods.specs) || [];
      } catch (e) {
        return [];
      }
    },
    tagNames() {
      const tagIds = this.parseGoodsTags(this.goods.tag);
      return tagIds.map(id => {
        const found = this.goodsTagOptions.find(item => item.id === id);
        return found ? found.name : id;
      });
    }
  },
  created() {
    this.getEnabledGoodsTagList();
    this.getDetail();
  },
  methods: {
    getValue,
    formatApiDate,
    getEnabledGoodsTagList() {
      getEnabledGoodsTagList().then(resp => {
        if (resp && resp.bizcode === 100) {
          this.goodsTagOptions = (resp.data && resp.data.entitys) || [];
        }
      });
    },
    getDetail() {
      const id = this.$route.params.id;
      if (!id) {
        return;
      }
      this.loading = true;
      getGoodsPreviewDetail({ id })
        .then(resp => {
          if (resp && resp.bizcode === 100) {
            this.goods = resp.data || {};
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    splitImages(value) {
      if (!value) {
        return [];
      }
      return String(value)
        .split(",")
        .map(item => item.trim())
        .filter(Boolean);
    },
    parseGoodsTags(tag) {
      if (Array.isArray(tag)) {
        return tag.map(item => Number(item)).filter(Boolean);
      }
      if (tag === null || tag === undefined || tag === "" || tag === 0 || tag === "0") {
        return [];
      }
      if (tag === 1 || tag === "1") {
        return [2];
      }
      try {
        const parsed = JSON.parse(tag);
        return Array.isArray(parsed)
          ? parsed.map(item => Number(item)).filter(Boolean)
          : String(tag)
              .split(",")
              .map(item => Number(item))
              .filter(Boolean);
      } catch (e) {
        return String(tag)
          .split(",")
          .map(item => Number(item))
          .filter(Boolean);
      }
    },
    goBack() {
      this.$router.push({ path: "/product/list", query: { isEdit: 1 } });
    }
  }
};
</script>

<template>
  <div v-loading="loading" class="app-container product-preview">
    <div class="preview-header">
      <div>
        <h2>{{ goods.name || "商品预览" }}</h2>
        <div class="sub-info">
          <span>ID：{{ goods.id || "-" }}</span>
          <span>店铺：{{ goods.shopName || "-" }}</span>
          <span>品牌：{{ goods.brandName || "-" }}</span>
        </div>
      </div>
      <el-button @click="goBack">返回列表</el-button>
    </div>

    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="never">
          <el-image class="main-image" :src="goods.mainGraph" fit="cover">
            <div slot="error" class="image-slot">暂无主图</div>
          </el-image>
          <div class="thumb-list" v-if="goodsImages.length">
            <el-image
              v-for="item in goodsImages"
              :key="item"
              class="thumb"
              :src="item"
              fit="cover"
            />
          </div>
        </el-card>
      </el-col>

      <el-col :span="16">
        <el-card shadow="never">
          <div class="price-line">
            <span class="price">￥{{ goods.adPrice || "0.00" }}</span>
            <span v-if="goods.minPrice"
              >规格价：￥{{ goods.minPrice
              }}<span v-if="goods.maxPrice"> - ￥{{ goods.maxPrice }}</span></span
            >
          </div>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="商品类型">{{
              getValue(PRODUCT_TYPE, goods.type) || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="状态">{{
              getValue(PRODUCT_STATUS, goods.status) || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="类目">{{
              goods.caterotyName || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="商户">{{ goods.mchName || "-" }}</el-descriptions-item>
            <el-descriptions-item label="限购数量">{{
              goods.buyLimit || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="发货时效">{{
              goods.deliveryTime || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="供货价"
              >￥{{ goods.supplyPrice || "0.00" }}</el-descriptions-item
            >
            <el-descriptions-item label="创建时间">{{
              goods.ctdate ? formatApiDate(goods.ctdate) : "-"
            }}</el-descriptions-item>
          </el-descriptions>

          <div class="tag-row">
            <span class="section-label">商品标签</span>
            <el-tag v-for="item in tagNames" :key="item" size="small" type="success">{{
              item
            }}</el-tag>
            <span v-if="!tagNames.length" class="empty-text">暂无标签</span>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="section-card" shadow="never">
      <div slot="header">商品规格</div>
      <div v-if="specsGroups.length" class="spec-groups">
        <div v-for="group in specsGroups" :key="group.type" class="spec-group">
          <span class="section-label">{{ group.type }}</span>
          <el-tag v-for="item in group.items" :key="item.n" size="small">{{ item.n }}</el-tag>
        </div>
      </div>
      <el-table v-if="goods.combs && goods.combs.length" :data="goods.combs" border size="small">
        <el-table-column label="图片" width="72">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.skuImage"
              :src="scope.row.skuImage"
              :preview-src-list="[scope.row.skuImage]"
              fit="cover"
              style="width: 44px; height: 44px"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="combNames" label="规格" min-width="180" />
        <el-table-column prop="skuName" label="条目名称" min-width="200" />
        <el-table-column prop="price" label="现价" width="120" />
        <el-table-column prop="originalPrice" label="划线价" width="120" />
        <el-table-column prop="supplyPrice" label="供货价" width="120" />
        <el-table-column prop="stock" label="库存" width="120" />
        <el-table-column prop="mchNo" label="商家编码" min-width="160" />
      </el-table>
      <el-empty
        v-if="!specsGroups.length && !(goods.combs && goods.combs.length)"
        description="暂无规格"
      />
    </el-card>

    <el-card class="section-card" shadow="never">
      <div slot="header">商品详情</div>
      <div v-if="goods.detailInfo" class="detail-content" v-html="goods.detailInfo"></div>
      <el-empty v-else description="暂无详情" />
    </el-card>
  </div>
</template>

<style scoped lang="scss">
.product-preview {
  .preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h2 {
      margin: 0 0 8px;
      font-size: 22px;
      font-weight: 600;
      color: #1f2937;
    }
  }

  .sub-info {
    display: flex;
    gap: 18px;
    color: #8a94a6;
    font-size: 13px;
  }

  .main-image {
    width: 100%;
    height: 360px;
    background: #f4f6f8;
  }

  .image-slot {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #909399;
  }

  .thumb-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 8px;
    margin-top: 12px;
  }

  .thumb {
    width: 100%;
    height: 64px;
    border: 1px solid #ebeef5;
  }

  .price-line {
    display: flex;
    align-items: baseline;
    gap: 16px;
    margin-bottom: 18px;
    color: #606266;
  }

  .price {
    color: #f56c6c;
    font-size: 26px;
    font-weight: 700;
  }

  .tag-row,
  .spec-group {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
    flex-wrap: wrap;
  }

  .section-label {
    color: #606266;
    font-weight: 600;
    margin-right: 4px;
  }

  .empty-text {
    color: #a8abb2;
  }

  .section-card {
    margin-top: 16px;
  }

  .spec-groups {
    margin-bottom: 16px;
  }

  .detail-content {
    line-height: 1.8;
    color: #303133;
    overflow: hidden;

    ::v-deep img {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 8px 0;
    }
  }
}
</style>
